import { Action } from '../../models/Action';
import { APP_CONSTANTS } from './constants';
import { Option } from '../../models/Option';
import { Speed } from '../../models';

export type AppState = {
  rows: Array<Array<number>> | null;
  columns: Array<Array<number>> | null;
  running: boolean;
  selectedOption: Option;
  speed: Option;
  clear: boolean;
};

const QR = {
  rows: [
    [7, 2, 2, 7],
    [1, 1, 1, 2, 1, 1],
    [1, 3, 1, 3, 1, 1, 3, 1],
    [1, 3, 1, 2, 1, 1, 3, 1],
    [1, 3, 1, 2, 1, 3, 1],
    [1, 1, 2, 2, 1, 1],
    [7, 1, 1, 1, 7],
    [2],
    [2, 3, 2, 1, 4],
    [1, 1, 3, 3, 2, 1],
    [3, 1, 3, 2, 2],
    [1, 1, 1, 3, 1, 1],
    [1, 5, 1, 1, 1, 1],
    [1, 1, 1, 1, 3, 1],
    [7, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1],
    [1, 3, 1, 1, 1, 2, 2],
    [1, 3, 1, 2, 1, 2, 1, 1],
    [1, 3, 1, 1, 1, 2],
    [1, 1, 2, 1, 1],
    [7, 1, 3, 1],
  ],
  columns: [
    [7, 1, 2, 7],
    [1, 1, 1, 1, 1, 1],
    [1, 3, 1, 1, 1, 3, 1],
    [1, 3, 1, 1, 1, 1, 3, 1],
    [1, 3, 1, 1, 1, 1, 3, 1],
    [1, 1, 2, 1, 1],
    [7, 1, 1, 1, 7],
    [4],
    [4, 2, 2, 2, 2, 2],
    [1, 2, 1, 1, 1, 2, 3],
    [1, 2, 2, 2],
    [2, 3, 1, 1, 1, 1, 1],
    [3, 3, 2, 3, 1, 1],
    [1, 1, 3, 2],
    [7, 1, 1],
    [1, 1, 1, 1, 1, 1, 1],
    [1, 3, 1, 3, 2, 3],
    [1, 3, 1, 2, 2, 1, 1],
    [1, 3, 1, 1, 1, 1, 1],
    [1, 1, 5, 3],
    [7, 1, 1, 2, 1],
  ]
};

const Bunny = {
  rows: [
    [5, 5],
    [3, 1, 2],
    [1, 5, 2],
    [1, 4, 5, 1],
    [8, 4, 1],
    [3, 4, 1],
    [2, 3, 1],
    [2, 3, 1],
    [3, 2, 1],
    [1, 2],
    [7, 1],
    [1, 1, 1, 2],
    [1, 1, 1, 1, 1, 1],
    [1, 2, 1, 1, 1],
    [2, 8, 1],
    [4, 4, 1, 4],
    [1, 1, 1, 1, 1],
    [3, 3, 1, 3],
    [1, 2, 1, 1, 1, 2],
    [1, 3, 1, 6, 1],
  ],
  columns: [
    [2],
    [2, 1, 1, 1],
    [1, 1, 1, 1, 1],
    [1, 2, 3, 1],
    [1, 2, 2, 2],
    [1, 2, 2, 2],
    [1, 3, 3, 1, 1],
    [1, 2, 1, 2, 2],
    [1, 6, 1, 2, 1],
    [2, 3, 1, 6],
    [1, 2, 1, 6, 1],
    [1, 4, 1, 1, 2],
    [1, 7, 1, 1, 1, 1, 1],
    [1, 7, 1, 1, 1],
    [2, 5, 2, 2, 1, 1],
    [2, 1, 1, 1],
    [10, 1, 2],
    [3, 1, 2],
    [4, 1],
    [1, 1],
  ],
};

const Aries = {
  rows: [
    [8],
    [3, 3, 3, 3],
    [10, 2, 10],
    [3, 2, 2, 2, 4, 2],
    [2, 2, 1, 2, 2, 2],

    [2, 6, 1, 1, 2],
    [1, 2, 2, 2, 2],
    [1, 2, 2, 2, 4, 2],
    [1, 2, 1, 1, 7, 2, 2],
    [1, 3, 1, 12],

    [2, 2, 12],
    [2, 2, 7, 3],
    [4, 7, 1, 1],
    [7, 2],
    [2, 8, 6],

    [4, 9, 9],
    [6, 24],
    [3, 4, 24],
    [3, 28],
    [3, 1, 24],

    [3, 19, 3],
    [6, 4, 5, 7, 2],
    [11, 6, 7],
    [4, 10, 2, 4],
    [4, 5, 8],

    [3, 3, 4],
    [2, 3, 3],
    [4, 3, 3],
    [3, 4, 4, 2, 1],
    [1, 3, 3, 3, 2, 1],

    [1, 5, 2, 3, 2],
    [2, 21, 2],
    [2, 3, 1],
    [1, 2, 1, 3, 2, 4, 4, 2],
    [2, 2, 1, 2, 1, 2, 2, 2, 2],

    [2, 4, 2, 1, 2, 3, 4, 1],
    [1, 2, 1, 3, 2, 2, 2, 3],
    [4, 1, 2, 2, 4, 4, 1, 1, 1],
    [4, 3, 1, 1],
    [23, 2, 1],
  ],
  columns: [
    [2, 4, 3],
    [3, 1, 2, 2, 1],
    [6, 4, 3, 2, 3, 1],
    [2, 2, 3, 4, 1, 2],
    [2, 2, 2, 3, 4, 2, 4, 1],

    [2, 4, 1, 4, 4, 1, 5, 2],
    [2, 2, 1, 1, 5, 3, 1, 1, 1, 2],
    [2, 1, 2, 2, 3, 3, 1, 5, 1],
    [2, 1, 1, 2, 2, 3, 2, 1],
    [3, 1, 4, 4, 1, 5, 1, 5, 1],

    [1, 1, 1, 9, 4, 1, 4, 1],
    [1, 1, 1, 12, 3, 1, 1, 2, 1],
    [1, 1, 1, 17, 1, 2, 1, 1],
    [1, 1, 19, 1, 1],
    [1, 2, 17, 1, 5, 1],

    [2, 2, 14, 1, 1, 5, 1],
    [2, 1, 5, 7, 2, 1, 1],
    [2, 1, 4, 9, 1, 5, 1],
    [2, 5, 1, 8, 2, 1, 5, 1],
    [5, 3, 1, 7, 3, 1, 1, 1, 1, 1],

    [7, 7, 3, 1, 1, 1, 1],
    [4, 9, 3, 1, 1],
    [2, 5, 5, 1, 3, 1, 1],
    [8, 3, 3, 3, 1, 1],
    [8, 2, 4, 1, 3, 1],

    [2, 11, 2, 1, 1, 3, 1],
    [4, 12, 2, 1, 2],
    [2, 1, 15, 1, 2],
    [3, 14, 2, 1],
    [7, 9, 2, 1, 1],

    [7, 6, 2, 3],
    [3, 7, 2, 1],
    [2, 1, 6, 2, 3, 4],
    [4, 4, 1, 2, 2, 1],
    [2, 4, 2, 1],
  ],
};

const Flower = {
  rows: [
    [3],
    [1, 1],
    [1, 1],
    [1, 2],
    [1, 1, 1, 2],

    [1, 1, 2, 2],
    [1, 6, 2, 1, 2],
    [1, 2, 2, 1, 5],
    [1, 2, 1, 1, 2],
    [1, 6, 1, 3],

    [2, 2, 2, 2, 2],
    [2, 3, 8],
    [2, 2, 2, 2],
    [2, 1, 1, 1],
    [2, 1, 2, 2],

    [2, 2, 2, 4, 1],
    [2, 2, 1, 3, 5],
    [2, 3, 4, 2, 1],
    [2, 14, 2],
    [2, 7, 4],

    [2, 3, 3],
    [2, 3, 2],
    [2, 3],
    [1, 22],
    [24],
  ],
  columns: [
    [20],
    [13, 1],
    [2],
    [2, 3],
    [3, 4],

    [1, 1, 5],
    [1, 1, 3, 2],
    [1, 2, 6, 2],
    [1, 11, 2],
    [1, 2, 3, 2],

    [2, 2, 2, 2, 2],
    [1, 9, 3, 2],
    [1, 5, 2],
    [3, 2, 2, 2],
    [4, 3, 2, 2],

    [8, 1, 1, 2],
    [3, 1, 1, 2],
    [2, 1, 1, 1, 2],
    [2, 2, 2, 1, 1, 2],
    [4, 2, 1, 1, 2],

    [1, 1, 2, 2, 2],
    [2, 1, 3, 1, 2],
    [2, 2, 5, 2],
    [3, 1, 4, 2],
    [4, 2, 1],
  ],
};

const Dog = {
  rows: [[4], [8, 2], [10, 5], [8, 5], [7, 2, 1, 5], [4, 4, 8], [4, 2, 2, 1, 6], [8, 8], [6, 1, 4], [4, 4], [3, 4, 3], [4, 3, 1], [4, 1, 1, 2], [1, 1, 1, 6, 1], [1, 1]],
  columns: [[4, 1], [7, 1], [9, 3], [13], [13], [4, 5], [4, 4, 1], [3, 4, 1, 1], [1, 2, 1, 1], [2, 4, 1, 1], [1, 2, 2, 1], [4], [3, 2, 1], [1, 2, 2, 2], [2, 3, 2, 1, 1], [10, 1], [9], [8], [6], [4]]
};

const Queen = {
  columns: [[33, 1, 6, 2], [1, 1, 1, 1, 2, 3, 2], [1, 4, 2, 3, 1, 1, 2, 1], [1, 6, 3, 1, 6, 1, 3], [1, 7, 3, 2, 3, 7], [1, 7, 1, 6, 2, 1, 2], [1, 8, 2, 7, 2, 3, 1], [1, 8, 3, 6, 3, 2, 2, 1], [1, 10, 3, 3, 4, 9, 2], [16, 4, 2, 1, 2, 4], [1, 10, 3, 3, 2, 2, 4, 2, 3], [1, 8, 3, 1, 4, 4, 2, 3, 2], [1, 8, 2, 3, 2, 3, 2, 2, 1], [1, 7, 1, 1, 2, 1, 2, 3, 5], [1, 7, 5, 4, 6, 1, 4], [1, 6, 1, 3, 1, 8, 2, 1, 2], [1, 4, 3, 2, 10, 1, 1, 1], [1, 19, 1], [1, 2, 1, 11, 2, 1], [1, 3, 1, 2, 10, 1], [1, 3, 1, 2, 1, 10, 1], [1, 6, 6, 2, 2, 14], [3, 2, 2, 1, 2, 5, 1, 10], [2, 1, 3, 1, 1, 1, 1, 2, 3, 10], [3, 1, 1, 1, 2, 1, 3, 13], [4, 1, 2, 1, 3, 1, 3, 12], [4, 1, 1, 4, 1, 2, 1, 14], [5, 1, 20], [7, 3, 1, 1, 15], [1, 12, 2, 1, 14], [2, 12, 2, 1, 13], [6, 10, 1, 1, 13], [2, 4, 7, 1, 11], [1, 2, 4, 5, 1, 10, 3], [2, 2, 5, 5, 9, 2], [3, 6, 4, 5, 8, 4], [1, 2, 2, 3, 2, 10], [4, 2, 5, 2, 7, 5], [3, 7, 3, 3, 2, 3, 1], [3, 2, 5, 3, 2, 3, 4, 2], [2, 2, 4, 2, 2, 3, 4], [2, 3, 3, 3, 2, 6], [1, 3, 2, 3, 9]],
  rows: [[22, 5, 3, 4, 3], [1, 1, 7, 3, 2, 4], [1, 3, 1, 5, 3, 5], [1, 3, 2, 4, 1, 2, 2, 3], [1, 5, 1, 3, 1, 2, 5], [1, 7, 1, 4, 2, 2, 2, 2], [1, 11, 2, 2, 1, 4], [1, 13, 5, 3, 1, 1, 2], [1, 15, 2, 1, 2, 2, 2, 1, 1], [1, 15, 1, 2, 2, 1, 2, 2], [1, 15, 2, 4, 1, 1, 2], [1, 15, 1, 4, 2, 2, 1], [1, 4, 1, 4, 3, 4, 1, 1, 2], [1, 3, 3, 3, 1, 1, 2], [1, 5, 2, 3, 1, 1, 1], [1, 7, 1, 4, 2, 2, 2], [1, 3, 3, 1, 3, 1, 1, 1], [1, 4, 3, 1, 2, 2], [1, 1, 3, 3, 4, 2, 1, 1], [1, 1, 3, 3, 2, 1, 3, 2, 2, 1], [1, 2, 1, 3, 1, 2, 1, 2, 2, 2], [1, 1, 2, 5, 2, 2, 5, 1, 1], [1, 2, 1, 2, 4, 4, 2, 2, 2, 2], [1, 2, 1, 2, 1, 2, 2, 5, 2, 2, 1], [4, 2, 6, 2, 5, 2, 2], [1, 3, 2, 2, 6, 15, 1], [1, 4, 2, 1, 1, 2, 1, 2, 2, 2], [1, 5, 2, 2, 1, 3, 1, 3, 1], [1, 6, 2, 4, 3, 3, 2, 1], [1, 4, 6, 7, 3, 1, 4], [3, 2, 2, 9, 1, 13], [1, 2, 2, 1, 26], [2, 1, 2, 2, 25, 1], [3, 2, 1, 25, 2], [2, 2, 3, 24, 1], [5, 1, 2, 22, 2], [1, 1, 2, 2, 2, 21, 1, 2], [3, 1, 3, 2, 19, 1, 1, 1], [5, 3, 2, 3, 1, 14, 1, 1, 1], [2, 2, 2, 1, 1, 4, 13, 3, 2], [1, 1, 1, 4, 2, 10, 3, 2], [1, 2, 2, 5, 1, 8, 1, 1, 1, 3], [4, 2, 1, 2, 7, 1, 1, 3], [2, 3, 4, 3, 4, 3, 4], [1, 9, 1, 2, 2, 5]]
};

const Something = {
  columns: [[23, 1], [9, 1, 2, 1], [4, 1, 2, 2, 1], [1, 8, 2, 1], [10, 6, 1], [4, 2, 1, 3, 1], [5, 2, 2, 1], [4, 4, 1, 2, 1], [1, 3, 3, 2, 1], [5, 2, 3, 2, 2], [8, 2, 3, 6], [10, 2, 3, 1, 2], [12, 2, 11, 1, 1], [1, 11, 5, 9, 2, 1], [2, 11, 11, 6, 8, 1], [3, 10, 5, 5, 5, 2, 1], [4, 8, 2, 3, 2, 3, 2, 1], [6, 5, 6, 6, 3, 1, 1], [5, 2, 3, 3, 8, 3, 1, 1], [6, 3, 2, 2, 1, 4, 2, 1], [7, 2, 6, 4, 2, 2], [1, 6, 6, 5, 2, 2], [1, 7, 4, 9, 2], [1, 8, 2, 11, 1], [1, 8, 8, 1, 1, 1], [1, 9, 8, 1, 2], [1, 9, 8, 1, 2], [1, 8, 8, 2, 2], [1, 8, 8, 2, 2], [1, 8, 7, 1, 2], [8, 7, 1, 1], [4, 7, 2, 1], [4, 9, 1, 1], [3, 9, 3, 1], [3, 8, 4, 1], [4, 6, 2, 1, 1], [1, 4, 2, 4, 1, 1, 1], [2, 4, 2, 3, 2, 1, 1], [3, 3, 5, 3, 2], [5, 3, 1, 2, 2, 2, 1], [6, 2, 1, 1, 1, 4, 1, 1], [7, 1, 2, 2, 4, 1, 1], [6, 1, 2, 2, 3], [4, 3, 3, 4], [3, 3, 1, 3, 3], [7, 1, 1, 5], [7, 1, 2, 5], [7, 1, 3, 5], [7, 2, 3], [5, 2, 6]],
  rows: [[4], [6], [1, 4, 1], [1, 7], [2, 5, 1], [3, 4, 2], [1, 1, 5, 1], [3, 5, 2], [2, 1, 4, 2], [3, 5, 1], [2, 1, 4, 1], [3, 4, 1], [1, 1, 3, 2], [3, 4, 1], [1, 1, 3, 1], [3, 3, 2], [1, 7], [3, 3, 1], [6, 1], [3, 5, 4], [9, 5, 1], [1, 2, 2, 4, 2], [1, 2, 3, 1, 4, 3], [1, 2, 5, 1, 4, 4], [1, 2, 6, 3, 9], [1, 1, 1, 2, 4, 2, 10], [1, 1, 1, 4, 6, 1, 9], [1, 3, 3, 8, 2, 5], [1, 2, 3, 10, 3, 4], [1, 1, 1, 2, 19, 3], [1, 1, 1, 2, 3, 20], [1, 1, 1, 1, 2, 17, 1], [1, 2, 3, 2, 2, 10, 2, 1], [2, 2, 3, 2, 3, 7, 2, 3, 1, 5], [2, 2, 6, 4, 6, 3, 5, 2], [2, 3, 2, 3, 4, 2, 4, 1, 2], [3, 1, 2, 2, 3, 5, 11], [5, 3, 4, 17], [7, 3, 16], [8, 23, 1], [2, 1, 2, 19, 3], [4, 1, 16, 1, 4], [1, 2, 1, 14, 1, 2, 4], [1, 4, 1, 10, 2, 8], [5, 1, 1, 2, 11, 1], [1, 2, 2, 22, 2, 3, 1], [17, 5, 2, 1, 5, 1, 1, 3, 1], [9, 1, 2, 11], [14, 14, 8], [12, 10, 12]]
};

const Bacterium = {
  columns: [[9, 4, 5, 9], [7, 6, 7, 3, 7], [6, 6, 7, 5, 6], [5, 4, 6, 5, 7, 5], [4, 6, 4, 3, 7, 4], [3, 7, 2, 1, 2, 5, 3], [2, 7, 2, 2, 2, 4, 3, 2], [1, 7, 1, 2, 2, 2, 1, 2, 5, 1], [1, 5, 1, 1, 9, 2, 1, 7, 1], [1, 1, 14, 1, 1, 7], [1, 18, 1, 6], [1, 29, 3], [4, 28, 2, 5], [5, 27, 1, 7], [6, 2, 24, 7], [12, 19, 8], [13, 27], [3, 7, 9, 9, 3], [9, 3, 7, 10], [2, 10, 1, 3, 7, 1, 8, 5], [3, 11, 1, 3, 7, 2, 6, 7], [4, 9, 1, 3, 7, 3, 5, 8], [18, 3, 7, 2, 13], [18, 7, 4, 6, 4], [4, 24, 3, 5, 2], [3, 1, 24, 3, 6, 2], [3, 12, 6, 7, 4, 5], [1, 11, 3, 6, 2, 12], [3, 10, 1, 3, 6, 7, 12], [16, 1, 3, 5, 2, 3, 6], [17, 1, 3, 5, 8, 3, 6], [16, 3, 5, 2, 7, 5], [6, 8, 5, 7, 6, 3], [6, 7, 7, 4, 4, 1], [5, 6, 7, 4, 4], [3, 6, 9, 4, 6, 3], [4, 14, 3, 6, 5], [2, 12, 2, 8, 6], [1, 12, 8, 10], [3, 22, 9], [3, 23, 8], [4, 3, 15, 1, 1, 7], [1, 6, 1, 2, 10, 3, 1, 5, 1, 1], [1, 8, 3, 2, 2, 1, 3, 3, 1, 1], [2, 8, 2, 3, 4, 6, 1, 1, 2], [3, 8, 4, 1, 1, 1, 1, 6, 3, 3], [4, 6, 6, 2, 8, 4], [5, 4, 8, 4, 8, 5], [6, 8, 6, 6, 6], [7, 8, 6, 4, 7], [9, 8, 5, 9]],
  rows: [[9, 8, 4, 9], [7, 8, 6, 7], [6, 4, 7, 8, 6], [5, 6, 4, 8, 5], [4, 6, 2, 8, 3, 4], [3, 6, 2, 1, 1, 6, 5, 3], [2, 5, 1, 2, 1, 3, 1, 7, 2], [1, 3, 2, 10, 2, 7, 1], [1, 4, 2, 21, 8, 1], [5, 23, 9], [6, 1, 21, 2, 5], [6, 26, 2, 3], [6, 27], [11, 20, 3, 2], [3, 3, 18, 6, 4], [3, 16, 7, 5], [6, 13, 5, 1, 6], [3, 4, 6, 7, 6], [5, 8, 3, 2, 3, 7, 8], [5, 6, 1, 1, 2, 1, 1, 16], [15, 5, 2, 5, 10, 5], [16, 5, 2, 5, 10, 4], [3, 10, 3, 2, 3, 13], [1, 10, 2, 6, 6], [31, 4, 2, 3], [2, 30, 4, 4], [5, 27, 1, 12], [34, 2, 6, 5], [32, 2, 4, 1, 4], [4, 20, 1, 3, 4, 2, 2], [4, 19, 1, 1, 2, 5, 1], [2, 9, 1, 1, 1, 4, 7, 2], [2, 7, 3, 1, 2, 1, 5, 4, 7], [16, 2, 1, 2, 6, 5, 7], [7, 8, 10, 2, 6, 6], [6, 11, 3, 3, 1, 1, 8, 6], [6, 10, 1, 1, 1, 1, 5, 1, 6], [4, 15, 1, 1, 1, 6, 1, 5], [2, 5, 11, 8, 2], [7, 22, 2], [7, 1, 18, 3], [6, 2, 17, 6], [1, 4, 2, 2, 7, 3, 9, 1], [1, 2, 4, 1, 3, 1, 2, 1, 9, 1, 1], [2, 5, 3, 1, 2, 1, 9, 1, 2], [3, 7, 5, 4, 8, 1, 3], [4, 7, 6, 6, 6, 2, 4], [5, 7, 6, 7, 5, 5], [6, 5, 5, 8, 6], [7, 3, 4, 8, 7], [9, 2, 6, 9]],
};

const GaryGrant = {
  columns: [[17], [17], [18], [11, 19], [3, 2, 20], [6, 2, 22], [7, 5, 2, 23], [21, 2, 5, 14], [26, 3, 3, 12], [26, 14, 8], [23, 13], [23, 14], [22, 10], [1, 18, 8], [5, 9, 6], [8, 6, 6], [9, 5, 2, 6], [11, 4, 4], [11, 2, 1, 3], [12, 3, 1, 3], [13, 3, 1, 1, 3], [14, 4, 1, 1, 3], [14, 4, 1, 1, 3], [15, 3, 2, 1, 3], [16, 2, 1, 1, 2, 4], [17, 1, 2, 4, 1, 1, 4], [17, 4, 3, 1, 2, 5], [17, 4, 3, 1, 2, 6], [17, 4, 2, 1, 2, 7], [3, 7, 5, 2, 1, 2, 5], [3, 7, 5, 2, 1, 2, 4], [3, 6, 5, 2, 1, 2, 4], [3, 6, 5, 2, 1, 1, 4], [4, 13, 5, 3, 1, 2, 5], [5, 13, 5, 6, 2, 1, 5], [5, 12, 1, 2, 4, 1, 6], [5, 12, 3, 1, 1, 7], [5, 11, 3, 1, 8], [5, 10, 4, 9], [6, 9, 4, 10], [6, 8, 3, 11], [1, 6, 8, 3, 1, 13], [1, 6, 8, 6, 16], [1, 1, 13, 5, 19], [2, 1, 13, 5, 20], [4, 1, 12, 5, 24], [5, 2, 14, 37], [6, 1, 55], [7, 1, 23, 29], [8, 1, 20, 31], [9, 1, 16, 33], [10, 4, 10, 35], [11, 2, 3, 37], [19, 1, 43], [20, 2, 41]],
  rows: [[20, 14], [24, 11], [27, 10], [15, 11, 10], [18, 9, 1, 9], [2, 18, 7, 1, 8], [3, 21, 6, 1, 7], [4, 23, 7, 6], [6, 24, 4, 1, 5], [6, 27, 4, 1, 4], [7, 31, 1, 3], [9, 10, 17, 1, 2], [10, 12, 17, 1, 2], [10, 29, 1, 2], [10, 29, 2], [10, 28, 2], [9, 26, 3], [8, 8, 9, 3], [10, 5, 8, 2], [9, 7, 1], [9, 8], [9, 7, 1], [10, 6, 2], [10, 5, 1], [2, 8, 5, 2], [1, 7, 5, 2], [1, 6, 5, 2], [1, 6, 5, 2], [1, 5, 5, 3], [1, 4, 5, 3], [1, 4, 6, 5, 4], [1, 4, 9, 8, 4], [1, 3, 2, 8, 8, 5], [1, 1, 2, 3, 2, 13, 5], [2, 2, 4, 14, 6], [2, 2, 2, 5, 2, 5, 3, 2, 6], [5, 2, 3, 2, 2, 9], [5, 1, 4, 9], [3, 2, 9], [3, 1, 9], [4, 9], [5, 10], [6, 1, 10], [3, 3, 1, 2, 10], [3, 4, 1, 2, 10], [4, 4, 2, 2, 11], [4, 4, 3, 3, 12], [5, 4, 9, 12], [7, 5, 7, 12], [7, 4, 13], [7, 3, 4, 4, 13], [8, 4, 12, 13], [8, 4, 14], [9, 5, 14], [9, 4, 2, 2, 15], [9, 4, 10, 16], [9, 4, 6, 17], [10, 3, 18], [10, 3, 1, 19], [10, 4, 2, 20], [10, 4, 4, 22], [10, 36], [10, 34], [10, 33], [10, 31]],
};

const Cats = {
  columns: [[8], [8, 3], [8, 6], [2, 4, 3, 2], [2, 5, 4, 2], [8, 5, 2], [8, 7, 2], [5, 4, 8, 1], [3, 7, 9, 1], [4, 6, 9, 1], [12, 3, 9, 1, 2], [8, 5, 3, 10, 1, 2], [9, 3, 14, 2, 2], [8, 13, 5], [2, 4, 13, 3], [2, 11, 11], [16, 5], [5, 3, 5, 6], [2, 5, 5, 7], [3, 4, 5, 9], [9, 4, 18], [9, 6, 17], [16, 13, 2], [4, 3, 3, 13], [2, 2, 5, 12], [8, 12, 2], [5, 4, 14], [11, 13], [2, 5, 2, 11], [3, 3, 2, 7], [8, 2, 2], [7, 3, 3, 4], [4, 4, 5, 2, 1], [2, 10, 2, 1], [10, 2], [10, 3], [10, 2], [9, 2], [9, 2], [8, 2], [7, 1], [3, 1], [3, 2], [6], [4]],
  rows: [[2, 2], [3, 4], [12], [12], [4, 2, 4], [4, 4, 5], [15], [8, 6], [1, 3, 11, 1], [3, 4, 6, 2, 3], [12, 3, 11], [8, 3, 2, 12], [3, 4, 3, 2, 3, 3, 4], [3, 9, 2, 3, 5, 4], [7, 4, 3, 13], [11, 3, 6, 5], [9, 3, 8], [8, 4, 5], [5, 4, 2], [3, 4, 2], [4, 6, 2], [4, 7, 2], [4, 7, 3], [6, 8, 5], [9, 9, 6], [11, 9, 7], [12, 10, 8], [12, 12, 8], [12, 13, 9], [12, 13, 9], [12, 13, 10], [2, 10, 13, 10], [2, 8, 13, 12], [2, 5, 4, 9], [2, 4, 4, 4, 4], [2, 3, 3, 3, 2], [2, 2, 3, 2], [3, 2, 6, 2], [4, 4, 2, 6, 2], [8, 3, 8]],
};

const Horse = {
  columns: [[7], [4, 3], [3, 3], [2, 2, 3], [2, 4, 3], [2, 1, 5], [2, 7], [2, 6, 2], [2, 1, 2, 1, 2, 1], [1, 2, 3, 1], [3, 5, 3, 3], [2, 2, 3, 7], [3, 2, 3, 7], [4, 2, 9], [2, 1, 8], [2, 2, 1, 6], [1, 2, 2, 6], [3, 2, 2, 2, 5, 3], [1, 3, 3, 1, 6, 2, 3], [3, 4, 1, 2, 2, 2, 4, 1, 3, 3], [2, 10, 5, 2, 3, 3, 5], [3, 3, 3, 4, 3, 3, 6, 2], [3, 1, 2, 2, 6, 3, 5, 3, 2, 1], [5, 4, 1, 1, 4, 3, 6, 4, 1], [20, 3, 7, 4], [2, 3, 9, 3, 9, 2], [3, 12, 11, 3], [4, 11, 16], [17, 2, 10, 4], [12, 5, 11], [8, 3, 1], [2, 3, 4, 2], [2, 24], [26], [2, 3, 21, 1], [3, 18, 3], [6, 22, 1], [2, 2, 18, 4], [3, 3, 3, 19, 1], [3, 5, 19, 1]],
  rows: [[3, 2], [4, 3], [1, 4, 2], [1, 3, 3], [1, 2, 2], [2, 3, 3], [7, 3, 3], [4, 2, 4, 7], [1, 2, 2, 6, 5], [1, 2, 3, 3, 3, 1, 2], [2, 1, 4, 4, 2, 1], [4, 8, 2, 2], [2, 3, 7, 1, 2], [3, 10, 1, 2], [2, 6, 3, 2], [2, 7, 3, 1, 1], [1, 4, 6, 3, 1, 1], [2, 11, 4, 1, 2], [2, 1, 9, 6, 1], [2, 8, 3, 6, 1], [1, 1, 2, 2, 2, 2, 6], [1, 2, 2, 3, 7], [3, 3, 3, 3, 8], [2, 2, 4, 3, 1, 9], [2, 2, 3, 2, 9], [2, 2, 2, 3, 2, 9], [2, 2, 3, 4, 3, 9], [2, 2, 2, 3, 4, 8], [2, 3, 5, 6, 8], [1, 5, 3, 7, 8], [2, 2, 3, 1, 8, 8], [1, 2, 2, 2, 9, 8], [2, 1, 17, 8], [2, 2, 3, 10, 1, 6], [1, 1, 4, 1, 8, 1, 1, 6], [1, 1, 1, 8, 1, 3, 1, 1, 5], [1, 3, 1, 7, 2, 2, 4, 1, 4], [1, 2, 2, 7, 1, 1, 3, 2, 3], [2, 1, 3, 3, 3, 2, 2, 5, 2], [2, 4, 2, 4, 1, 1, 3, 2], [7, 3, 5, 5, 1], [5, 2, 3, 5, 3], [8, 4, 1, 1, 1, 1], [3, 1, 1, 1, 1], [2, 2, 1]],
};

const Gandalf = {
  columns: [[2], [4], [11, 2], [9, 1], [6, 8, 3], [6, 3, 1], [3, 1, 4, 3], [2, 7, 10, 1], [14, 4, 1, 8], [3, 2, 4, 2], [3, 6, 2], [2, 3, 8], [6, 3], [5, 36], [2, 28, 2, 2], [1, 1, 2, 16, 9, 2, 1, 2], [1, 1, 4, 2, 9, 9, 2, 3], [1, 1, 2, 3, 8, 1, 10, 2], [2, 2, 8, 3, 1, 6, 2, 3], [1, 1, 4, 4, 1, 4], [1, 1, 3, 3, 2, 3], [1, 1, 3, 3, 1, 2, 2], [2, 2, 2, 3, 1, 4, 3, 6], [2, 1, 12, 2, 2, 3], [1, 1, 1, 8, 2, 2, 2], [1, 2, 1, 9, 2, 2, 8], [1, 1, 1, 3, 2, 1, 2], [1, 2, 1, 4, 2, 4], [1, 1, 3, 4, 2, 1, 3], [1, 1, 1, 1, 2, 2, 4, 1], [1, 1, 1, 2, 1, 2, 2, 4], [2, 1, 2, 3, 2, 2, 3, 2], [1, 1, 2, 3, 2, 1, 1, 2, 1], [2, 1, 2, 3, 1, 2, 3, 2, 2], [1, 2, 2, 2, 1, 2, 2, 3, 3], [2, 2, 2, 2, 1, 3, 1, 2, 2, 2], [12, 3, 2, 1, 8, 4], [2, 7, 3, 1, 1, 1, 9, 4], [2, 10, 15, 1, 1], [4, 31], [2, 2, 1, 22], [2, 9, 3, 11], [3, 9, 2, 1, 3], [3, 4, 4, 2, 1, 1], [3, 6, 2, 3, 4], [6, 5, 2, 2, 2], [3, 3, 2, 4], [7, 6, 4, 2], [3, 2, 5], [7, 6, 2]],
  rows: [[15, 5], [3, 1, 2, 1, 3], [3, 2, 2, 2, 2], [4, 1, 5, 1, 2, 2], [1, 2, 2, 3, 1, 3, 2], [1, 1, 2, 2, 2, 2, 1, 1], [1, 1, 2, 1, 3, 2], [2, 1, 3, 2, 2], [2, 1, 1, 1, 1, 3], [1, 2, 1, 1, 2, 1, 1], [2, 1, 2, 1, 2, 1, 1], [2, 1, 3, 1, 2, 1, 1], [1, 1, 1, 3, 1, 2, 3], [1, 1, 1, 4, 1, 2, 1, 1], [1, 1, 1, 4, 1, 1, 1, 2], [1, 1, 1, 3, 2, 2, 1, 1], [1, 1, 1, 9, 1, 1, 5, 1, 1, 1], [1, 1, 13, 1, 1, 9, 1, 1, 1], [2, 1, 15, 4, 3, 1, 1, 1], [1, 1, 8, 4, 2, 3, 3, 1], [1, 2, 1, 5, 7, 6, 8], [1, 1, 1, 1, 13, 9, 1, 3], [1, 1, 1, 1, 13, 1, 2, 1, 3], [1, 1, 1, 7, 3, 1, 2, 1, 1, 2], [1, 1, 1, 4, 4, 2, 3, 1, 1, 1], [1, 1, 1, 3, 1, 2, 2, 3, 1, 1, 1, 1], [1, 1, 1, 2, 3, 1, 1, 1, 1, 1], [1, 1, 3, 1, 2, 1, 1, 1], [1, 2, 4, 2, 3, 1, 1, 1], [1, 1, 5, 1, 1, 3, 1, 1, 2], [1, 1, 6, 2, 3, 3, 4, 1, 1, 1], [1, 1, 6, 8, 1, 3, 1, 1, 1], [1, 1, 6, 6, 2, 5, 1, 1, 1], [1, 1, 6, 2, 2, 5, 1, 1, 1], [1, 1, 6, 1, 6, 1, 1, 1], [2, 1, 1, 4, 6, 2, 1, 1, 1], [1, 2, 1, 2, 8, 5, 1, 1, 1], [1, 1, 1, 1, 1, 10, 6, 1, 1, 1], [1, 1, 1, 1, 2, 2, 1, 5, 1, 1, 1], [1, 1, 1, 1, 1, 2, 10, 2, 2], [1, 1, 1, 1, 1, 1, 2, 4, 7, 1, 2], [1, 1, 2, 1, 1, 1, 1, 4, 4, 2, 1, 4, 1, 1], [1, 1, 1, 1, 2, 1, 1, 3, 1, 1, 1, 1, 2, 3, 2, 1], [1, 1, 1, 1, 2, 2, 1, 2, 1, 1, 1, 1, 2, 1, 3, 1, 1], [1, 3, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 4, 1, 1], [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 1, 3], [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1], [1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1], [3, 1, 1, 2, 2, 1, 2, 2, 1, 1, 1, 2, 4, 6], [10, 1, 1, 1, 1, 1, 1, 1, 1, 12]],
};

export const NonogramOptions: Option[] = [
  {
    label: 'QR code',
    value: 1,
  },
  {
    label: 'Custom Field',
    value: -1,
  },
  {
    label: 'Bunny',
    value: 2,
  },
  {
    label: 'Aries',
    value: 3,
  },
  {
    label: 'Flower',
    value: 4,
  },
  {
    label: 'Dog',
    value: 5,
  },
  {
    label: 'Queen of Spades',
    value: 6,
  },
  {
    label: 'Something',
    value: 7,
  },
  {
    label: 'Bacterium',
    value: 8,
  },
  {
    label: 'Gary Grant',
    value: 9,
  },
  {
    label: 'Cats',
    value: 10,
  },
  {
    label: 'Horse',
    value: 11,
  },
  {
    label: 'Gandalf',
    value: 12,
  }
];

const imagesMapper = (value: number): { rows: Array<Array<number>> | null, columns: Array<Array<number>> | null } => {
  const image: any = {
    1: QR,
    2: Bunny,
    3: Aries,
    4: Flower,
    5: Dog,
    6: Queen,
    7: Something,
    8: Bacterium,
    9: GaryGrant,
    10: Cats,
    11: Horse,
    12: Gandalf,
  };

  const response = image[value];

  if (response) {
    return response;
  }

  return {
    rows: null,
    columns: null,
  };
};

export const SpeedOptions: Option[] = [
  {
    label: 'Slow',
    value: Speed.slow,
  },
  {
    label: 'Medium',
    value: Speed.medium,
  },
  {
    label: 'Fast',
    value: Speed.fast,
  },
];

const initialState: AppState = {
  ...imagesMapper(NonogramOptions[0].value),
  selectedOption: NonogramOptions[0],
  running: false,
  speed: SpeedOptions[2],
  clear: false,
};

const app = (state: AppState = initialState, action: Action) => {
  switch (action.type) {
    case APP_CONSTANTS.SET_RUNNING: {
      return {
        ...state,
        running: action.payload,
      };
    }
    case APP_CONSTANTS.CHANGE_OPTION: {
      const option: Option = action.payload;
      return {
        ...state,
        ...imagesMapper(option.value),
        selectedOption: option,
        running: false,
      }
    }
    case APP_CONSTANTS.CHANGE_SPEED: {
      const option: Option = action.payload;
      return {
        ...state,
        speed: option,
      };
    }
    case APP_CONSTANTS.CLEAR_FIELD: {
      return {
        ...state,
        clear: action.payload,
      };
    }
    case APP_CONSTANTS.SET_CUSTOM_FIELD: {
      return {
        ...state,
        rows: action.payload.rows,
        columns: action.payload.columns,
      };
    }
    default: {
      return state;
    }
  }
};

export default app;
